"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var classnames_1 = __importDefault(require("classnames"));
var index_module_scss_1 = __importDefault(require("./index.module.scss"));
var MobileFiltersMenu = function (_a) {
    var children = _a.children;
    if (typeof document !== 'object' || !document.querySelector('.store-menu'))
        return react_1.default.createElement("div", { className: (0, classnames_1.default)(index_module_scss_1.default.menu) });
    return react_dom_1.default.createPortal(react_1.default.createElement("div", { className: (0, classnames_1.default)(index_module_scss_1.default.menu) }, children), document.querySelector('.store-menu'));
};
exports.default = MobileFiltersMenu;
